'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _image = require('common/components/image');

var _image2 = _interopRequireDefault(_image);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _signatureEditArea = require('./signature-edit-area');

var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);

var _propTypes = require('./prop-types');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PropTypes = _react2['default'].PropTypes;


var UploadTab = _react2['default'].createClass({
    displayName: 'UploadTab',


    propTypes: _extends({}, _propTypes.CommonTabProps, {
        getSignatureUrl: _propTypes.GetSignatureUrl,
        isUploading: PropTypes.bool,
        onRotateSignature: PropTypes.func.isRequired,
        onSignatureData: _propTypes.OnSignatureData,
        onUpload: PropTypes.func.isRequired,
        signature: _propTypes.SignatureType
    }),

    //  ----  LIFECYCLE  ----------------------------------

    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'isSpinnerShown': false,
            'isEditAreaShown': false,
            'signature': null
        };
    },


    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {

        var uploadEditArea = this.refs.uploadEditArea;
        var signatureData = {};
        var isCropped = uploadEditArea.state.isCropped;

        if (isCropped) {
            signatureData = {
                'is_cropped': isCropped,
                'x': uploadEditArea.state.cropX,
                'y': uploadEditArea.state.cropY,
                'width': uploadEditArea.state.cropWidth,
                'height': uploadEditArea.state.cropHeight
            };
        }

        signatureData.create_type_code = _constants2['default'].SIGNATURE_TYPE_UPLOAD;
        signatureData.threshold = uploadEditArea.state.contrastValue;
        signatureData.degrees = uploadEditArea.state.degreesValue;

        return this.props.onSignatureData(signatureData, insertEverywhere);
    },


    //  ----  HELPERS  ------------------------------------

    onDrop: function onDrop(files) {
        var _this = this;

        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var file, has_errors;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            file = files[0]; // We only accept one

                            has_errors = !_this.checkTypeAndSize(file);

                            if (has_errors) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt('return', _this.props.onUpload(file));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    showEditArea: function showEditArea() {
        this.setState({
            'isEditAreaShown': true
        });
    },
    hideEditArea: function hideEditArea() {
        this.setState({
            'isEditAreaShown': false
        });
    },
    showSpinner: function showSpinner() {
        this.setState({
            'isSpinnerShown': true
        });
    },
    hideSpinner: function hideSpinner() {
        this.setState({
            'isSpinnerShown': false
        });
    },
    checkTypeAndSize: function checkTypeAndSize(file) {
        return this.checkFileExtension(file) && this.checkFileSize(file);
    },
    checkFileExtension: function checkFileExtension(file) {
        if (file.type && _constants2['default'].ACCEPTED_UPLOAD_TYPES.indexOf(file.type) === -1) {

            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileType' }, { 'fileType': file.type }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileFormats' });

            this.props.onError(new Error(errorMessage));
            return false;
        }
        return true;
    },
    checkFileSize: function checkFileSize(file) {
        if (file.size && file.size > _constants2['default'].MAX_UPLOAD_SIZE) {

            var formattedSize = Math.round(file.size / 1000000) + 'MB';

            var errorMessage = this.props.intl.formatMessage({ id: 'signModal.upload.error.fileSize' }, { 'fileSize': formattedSize }) + ' ' + this.props.intl.formatMessage({ id: 'signModal.upload.instructions.fileSize' });

            this.props.onError(new Error(errorMessage));
            return false;
        }
        return true;
    },


    //  ----  RENDERING  ----------------------------------

    renderUploadArea: function renderUploadArea() {

        var show = this.props.signature ? { 'display': 'none' } : {};
        var btnText = this.props.intl.formatMessage({ id: 'signModal.upload.button.text' });

        var uploadButton = _react2['default'].createElement(
            _reactDropzone2['default'],
            { onDrop: this.onDrop,
                onClick: this.onDrop,
                multiple: false,
                ref: 'dropzone', className: 'whitelabel-primary-button dropzone',
                style: {
                    'width': 60 + btnText.length * 10,
                    'height': 40
                } },
            _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(_image2['default'], { src: require('./upload_icon@2x.png') }),
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.button.text' })
            )
        );

        return _react2['default'].createElement(
            'div',
            { className: 'm-sign-modal--tabs--upload--fileupload', style: show },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--upload--header-text' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, {
                    id: 'signModal.upload.instructions.header',
                    values: { type: this.props.type } })
            ),
            uploadButton,
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--upload--file-formats-text' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.instructions.fileSize' }),
                _react2['default'].createElement('br', null),
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.upload.instructions.fileFormats' })
            )
        );
    },
    renderEditArea: function renderEditArea() {
        var _props = this.props,
            getSignatureUrl = _props.getSignatureUrl,
            intl = _props.intl,
            onRotateSignature = _props.onRotateSignature,
            signature = _props.signature,
            type = _props.type;


        var show = !signature ? { display: 'none' } : {};

        return _react2['default'].createElement(
            'div',
            { style: show },
            _react2['default'].createElement(_signatureEditArea2['default'], {
                getSignatureUrl: getSignatureUrl,
                intl: intl,
                onRotate: onRotateSignature,
                ref: 'uploadEditArea',
                signature: signature,
                type: type
            })
        );
    },
    render: function render() {
        var _props2 = this.props,
            actionBarProps = _props2.actionBarProps,
            isUploading = _props2.isUploading;


        var spinner;

        var inputClasses = {
            'm-sign-modal--tabs--upload--input': true
        };
        var classes = {
            'm-sign-modal--tabs--upload': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_UPLOAD] = true;

        if (isUploading) {
            spinner = _react2['default'].createElement('img', { src: require('./loading-spinner-16.gif'), className: 'm-sign-modal--tabs--upload--output--spinner' });
        }

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses), ref: 'uploadTab' },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--tab-title' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, {
                    id: 'signModal.upload.title',
                    values: { type: this.props.type }
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])(inputClasses) },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
                        this.renderUploadArea(),
                        spinner,
                        this.renderEditArea()
                    )
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
                disableButtons: !this.props.signature,
                onInsert: this.insertSignature,
                values: { type: this.props.type }
            }))
        );
    }
});

module.exports = UploadTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/upload-tab.jsx
 ** module id = 812
 ** module chunks = 0 1
 **/